import { FC } from 'react';

import { HistoryMovement } from 'types';

import ReclassificationTableRow from './ReclassificationTableRow';
import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';

const ReclassificationTableBody: FC = () => {
  const { data } = useHistoryMovementsView();

  return (
    <tbody>
      {data.historyMovements?.map(
        (movement: HistoryMovement, index: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr className="tb-tnx-item" key={`movement-${index}`}>
            <ReclassificationTableRow movement={movement} index={index} />
          </tr>
        )
      )}
    </tbody>
  );
};

export default ReclassificationTableBody;
